import { Clause, LegalShell } from "@/components/LegalShell";

export default function Privacy() {
  return (
    <LegalShell title="Privacy Policy" updated="29 June 2026">
      <p className="text-sm text-slate-600 leading-relaxed" data-testid="privacy-intro">
        Unbound is used by children and teenagers, so we collect as little as we can get away with and we say plainly
        what we do with it.
      </p>

      <Clause n={1} title="What we store">
        <p>
          Your name, email, date of birth (to know your age and suggest a level), country and timezone, and the answers
          you give during setup: your schooling situation, how confident you feel in a few subjects, anything you tell us
          makes learning harder, how you like to learn, your goal in your own words, your interests, and how much time
          you have.
        </p>
        <p>
          Then the learning itself: your curriculum, your progress, which cards you understood, what you asked the
          teacher, your practice and test answers, and what you got stuck on.
        </p>
      </Clause>

      <Clause n={2} title="What we don't collect">
        <p>
          No home address, no phone number, no payment details, no ID documents, no location tracking, no advertising
          identifiers. We do not sell data, and we do not run advertising.
        </p>
      </Clause>

      <Clause n={3} title="Why we store it">
        <p>
          Every field exists to make the teaching better: your age sets the language, your level sets the depth, your
          interests only feed the real-world examples, and "what makes learning harder" changes how explanations are
          written. Nothing here is used for profiling beyond teaching you.
        </p>
      </Clause>

      <Clause n={4} title="AI processing">
        <p>
          To generate lessons, a summary of your profile (never your email or password) is sent to our AI provider along
          with the topic being taught. Retrieval of references calls public sources such as arXiv, Open Library and
          encyclopaedic APIs. We keep a metering record of each generation — which agent ran, size and estimated cost —
          so we can keep the platform free and stable.
        </p>
      </Clause>

      <Clause n={5} title="Guardians and visibility">
        <p>
          If you invite a guardian, they can see your progress, your active plan and your stuck list. They cannot see
          your password. If you remove them, their access ends immediately. If you never add one, nobody else sees your
          learning.
        </p>
      </Clause>

      <Clause n={6} title="Security">
        <p>
          Passwords are stored as bcrypt hashes — we cannot read them. Sessions expire, and changing your password signs
          out every other device. Repeated failed sign-ins trigger a temporary lockout.
        </p>
      </Clause>

      <Clause n={7} title="Your choices">
        <p>
          You can edit or clear almost everything from your Profile page at any time, including removing your guardian
          and rewriting your goal. You can request a copy of your data or full deletion of your account and learning
          history.
        </p>
      </Clause>

      <Clause n={8} title="Retention">
        <p>
          We keep learning data while your account is open, because it is what makes your curriculum continuous. Metering
          records are kept in aggregate for cost control. On deletion, your profile and learning data are removed.
        </p>
      </Clause>

      <Clause n={9} title="Questions">
        <p>
          If a learner or guardian wants to know what we hold, or wants it deleted, ask through the account that owns the
          data and we will act on it.
        </p>
      </Clause>
    </LegalShell>
  );
}
